import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-info-dialog',
  imports: [
    MatDialogContent,
    MatButton,
    MatDialogClose,
    MatDialogActions,
    TranslatePipe,
  ],
  templateUrl: './info-dialog.component.html',
})
export class InfoDialogComponent {
  info: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: { info: string }) {
    this.info = data.info;
  }
}
